import { GeoLocationStatus } from '@endeavour/enhanced-geo-integration';
import { GeoLocationError } from '@endeavour/enhanced-geo-integration/src/interface/errors.interface';
import { WebSdk } from '@xpointtech/xpoint-js';
import { convertStatus, convertError, isCustomEvent } from './util.js';

const handleError = (error) => {
    if (error && error.message === 'Local service is not launched') {
        return {
            status: GeoLocationStatus.DENIED,
            errors: [GeoLocationError.SOFTWARE_NOT_RUNNING],
            token: '',
        };
    }
    throw error;
};
const createXPointIntegration = (clientKey) => {
    let sdk = null;
    const getSdk = () => {
        if (!sdk) {
            sdk = new WebSdk();
        }
        return sdk;
    };
    const decodeToken = (token) => {
        const [_, payload] = token.split('.');
        return JSON.parse(atob(payload));
    };
    let lastToken = undefined;
    return {
        isVerifyRunning() {
            return getSdk().isVerifyActive();
        },
        getCurrentToken() {
            return lastToken;
        },
        getTokenExpiryTimestamp() {
            if (!lastToken) {
                return 0;
            }
            return +decodeToken(lastToken).exp;
        },
        async getDetectedLocationInformation() {
            try {
                const resp = await getSdk().checkStatus();
                lastToken = resp.jwt;
                return {
                    token: resp.jwt,
                    status: convertStatus(resp.status),
                    errors: (resp.errors ?? []).map((error) => {
                        return convertError(error);
                    }),
                };
            }
            catch (e) {
                return handleError(e);
            }
        },
        onLocationRefreshed(handler) {
            const xpointHandler = (event) => {
                if (!isCustomEvent(event)) {
                    return;
                }
                const detail = event.detail;
                if (!detail) {
                    return;
                }
                lastToken = detail.jwt;
                handler({
                    token: detail.jwt,
                    status: convertStatus(detail.status),
                    errors: (detail.errors ?? []).map((error) => {
                        return convertError(error);
                    }),
                });
            };
            window.addEventListener('xpoint-sdk-message', xpointHandler);
            return () => window.removeEventListener('xpoint-sdk-message', xpointHandler);
        },
        startLocationCheck(info) {
            getSdk().setUserId(info.userProfileId, clientKey);
            return getSdk().wageringStart().catch(handleError);
        },
        endLocationCheck() {
            return getSdk().wageringEnd().catch(handleError);
        },
    };
};

export { createXPointIntegration };
